import { useDispatch, useSelector } from 'react-redux'
import {
  selectCanPrint,
  selectIsCashier,
  toggleCanPrint,
} from '../../app/store/app/app.state'
import Toggle from '../toggle/toggle'

const TogglePrintButton = () => {
  const dispatch = useDispatch()
  const isCashier = useSelector(selectIsCashier)
  const canPrint = useSelector(selectCanPrint)

  const handleCanPrint = () => dispatch(toggleCanPrint())

  if (isCashier) {
    return (
      <>
        <Toggle
          onChange={handleCanPrint}
          isOn={canPrint}
          title="Print Betslip"
          id="simulate-printBet"
        />
      </>
    )
  }

  return <></>
}

export default TogglePrintButton
